import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=35f55a00&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./ResetPassword.vue?vue&type=style&index=0&id=35f55a00&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "35f55a00",
  null
  ,true
)

export default component.exports